import React from 'react';
import AppErrorBoundary from './AppErrorBoundary.js';
import MainContainer from './MainContainer.js';

const withMainContainer = (Comp, props={})=>_props=><MainContainer {...props}>
  <AppErrorBoundary>
    <Comp {..._props}/>
  </AppErrorBoundary>
</MainContainer>;

export default withMainContainer;
